/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Submitted_ToastInputs */

const en_embed_captions_submitted_toast = /** @type {(inputs: Embed_Captions_Submitted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed job submitted successfully`)
};

const fr_embed_captions_submitted_toast = /** @type {(inputs: Embed_Captions_Submitted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tache d'incrustation soumise avec succes`)
};

const de_embed_captions_submitted_toast = /** @type {(inputs: Embed_Captions_Submitted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einbettungsauftrag erfolgreich übermittelt`)
};

const it_embed_captions_submitted_toast = /** @type {(inputs: Embed_Captions_Submitted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpora lavoro inviato con successo`)
};

const ru_embed_captions_submitted_toast = /** @type {(inputs: Embed_Captions_Submitted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задание на встраивание успешно отправлено.`)
};

const es_embed_captions_submitted_toast = /** @type {(inputs: Embed_Captions_Submitted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajo insertado enviado exitosamente`)
};

const zh_cn2_embed_captions_submitted_toast = /** @type {(inputs: Embed_Captions_Submitted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`嵌入式作业已成功提交`)
};

const ja_embed_captions_submitted_toast = /** @type {(inputs: Embed_Captions_Submitted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`埋め込みジョブが正常に送信されました`)
};

const hi_embed_captions_submitted_toast = /** @type {(inputs: Embed_Captions_Submitted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एम्बेड जॉब सफलतापूर्वक सबमिट हो गई`)
};

const pt_pt2_embed_captions_submitted_toast = /** @type {(inputs: Embed_Captions_Submitted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalho incorporado submetido com sucesso`)
};

/**
* | output |
* | --- |
* | "Embed job submitted successfully" |
*
* @param {Embed_Captions_Submitted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_submitted_toast = /** @type {((inputs?: Embed_Captions_Submitted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Submitted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_submitted_toast(inputs)
	if (locale === "de") return de_embed_captions_submitted_toast(inputs)
	if (locale === "it") return it_embed_captions_submitted_toast(inputs)
	if (locale === "ru") return ru_embed_captions_submitted_toast(inputs)
	if (locale === "es") return es_embed_captions_submitted_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_submitted_toast(inputs)
	if (locale === "ja") return ja_embed_captions_submitted_toast(inputs)
	if (locale === "hi") return hi_embed_captions_submitted_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_submitted_toast(inputs)
	return en_embed_captions_submitted_toast(inputs)
});